module.exports = __webpack_public_path__ + "static/GorditaBold-Italic-62ebcf52fdcbac9c7120a94052ec4f38.woff";